module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9506_ivory.85a43b9a.jpg";